import React, { useEffect, useState } from "react";
import {
    Box,
    Grid,
    TextField,
    Typography,
    Button,
} from "@mui/material";
import { store } from "../../redux/store";
import * as providerActions from '../../redux/actions/providerActions';

const ProfileForm = ({ handleClose, profileData }) => {

    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        registrationNumber: "",
        phoneNumber: "",
        email: "",
        designation: "",
        aboutMe: "",
    });

    useEffect(() => {
        const details = {
            firstName: profileData?.basicInfo?.firstName,
            lastName: profileData?.basicInfo?.lastName,
            registrationNumber: profileData?.registrationNumber || '',
            phoneNumber: profileData?.about?.contact?.phone,
            email: profileData?.about?.contact?.email,
            designation: profileData?.basicInfo?.designation,
            aboutMe: profileData?.about?.description,
        }
        setFormData(details)
    }, [profileData])

    const handleChange = (field) => (event) => {
        let value = event.target.value;
        if (field === "aboutMe") {
            const words = value.trim().split(/\s+/);
    
            if (words.length > 100) {
                value = words.slice(0, 100).join(" ");
            }
        }
    
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleSave = () => {
        handleClose()
        const { registrationNumber,phoneNumber, ...newObj } = formData;
        store.dispatch(providerActions.updateProviderDataRequestAction(newObj))
    };

    const handleCancel = () => {
        setFormData({
            firstName: "",
            lastName: "",
            registrationNumber: "",
            phoneNumber: "",
            email: "",
            designation: "",
            hospitals: [],
            aboutMe: "",
        });
        handleClose()
    };

    const wordCount = formData.aboutMe
    ? formData.aboutMe.trim().split(/\s+/).filter(Boolean).length
    : 0;
    
    return (
        <Box sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        }}>
            <Grid container spacing={3}>
                {/* First Name */}
                <Grid size={{ md: 6, sm: 12, xs: 12 }} >

                    <Typography sx={{ display: 'flex', justifyContent: 'flex-start', fontSize: '13px', color: '#6e6464' }}>First Name</Typography>
                    <TextField fullWidth placeholder="Name..." value={formData.firstName}
                        onChange={handleChange("firstName")} sx={{
                            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
                            borderRadius: '10px',
                            '& .MuiOutlinedInput-root': {
                                height: '40px',
                                borderRadius: '10px',
                                '& fieldset': {
                                    border: 'none',
                                },
                                '& input': {
                                    padding: '0 14px',
                                    height: '40px',
                                    boxSizing: 'border-box',
                                },
                            },
                        }} />
                </Grid>

                {/* Last Name */}
                <Grid size={{ md: 6, sm: 12, xs: 12 }}>
                    <Typography sx={{ display: 'flex', justifyContent: 'flex-start', fontSize: '13px', color: '#6e6464' }}>Last Name</Typography>
                    <TextField fullWidth placeholder="Name..." value={formData.lastName}
                        onChange={handleChange("lastName")} sx={{
                            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
                            borderRadius: '10px',
                            '& .MuiOutlinedInput-root': {
                                height: '40px',
                                borderRadius: '10px',
                                '& fieldset': {
                                    border: 'none',
                                },
                                '& input': {
                                    padding: '0 14px',
                                    height: '40px',
                                    boxSizing: 'border-box',
                                },
                            },
                        }} />
                </Grid>

                {/* Registration */}
                <Grid size={{ md: 12 }} >
                    <Typography sx={{ display: 'flex', justifyContent: 'flex-start', fontSize: '13px', color: '#6e6464' }}>Registration Number</Typography>
                    <TextField fullWidth value={formData.registrationNumber}
                         disabled={true} sx={{
                            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
                            borderRadius: '10px',
                            '& .MuiOutlinedInput-root': {
                                height: '40px',
                                borderRadius: '10px',
                                '& fieldset': {
                                    border: 'none',
                                },
                                '& input': {
                                    padding: '0 14px',
                                    height: '40px',
                                    boxSizing: 'border-box',
                                },
                            },
                        }} />
                </Grid>

                {/* phoneNumber */}
                <Grid size={{ md: 12 }} >
                    <Typography sx={{ display: 'flex', justifyContent: 'flex-start', fontSize: '13px', color: '#6e6464' }}>Phone No.</Typography>
                    <Box sx={{ position: "relative" }}>
                        <TextField fullWidth value={formData.phoneNumber} disabled={true}
                            sx={{
                                boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
                                borderRadius: '10px',
                                '& .MuiOutlinedInput-root': {
                                    height: '40px',
                                    borderRadius: '10px',
                                    '& fieldset': {
                                        border: 'none',
                                    },
                                    '& input': {
                                        padding: '0 14px',
                                        height: '40px',
                                        boxSizing: 'border-box',
                                    },
                                },
                            }} />
                    </Box>
                </Grid>

                {/* Email */}
                <Grid size={{ md: 12 }} >
                    <Typography sx={{ display: 'flex', justifyContent: 'flex-start', fontSize: '13px', color: '#6e6464' }}>Email Address</Typography>
                    <TextField fullWidth value={formData.email}
                        onChange={handleChange("email")} sx={{
                            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
                            borderRadius: '10px',
                            '& .MuiOutlinedInput-root': {
                                height: '40px',
                                borderRadius: '10px',
                                '& fieldset': {
                                    border: 'none',
                                },
                                '& input': {
                                    padding: '0 14px',
                                    height: '40px',
                                    boxSizing: 'border-box',
                                },
                            },
                        }} />
                </Grid>

                {/* Qualifications */}
                <Grid size={{ md: 12 }} >
                    <Typography sx={{ display: 'flex', justifyContent: 'flex-start', fontSize: '13px', color: '#6e6464' }}>Qualifications</Typography>
                    <TextField
                        fullWidth
                        multiline
                        minRows={2}
                        value={formData.designation}
                        onChange={handleChange("designation")}
                        sx={{
                            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
                            borderRadius: '10px',
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '10px',
                                '& fieldset': {
                                    border: 'none',
                                },
                                '& input': {
                                    padding: '0 14px',
                                    boxSizing: 'border-box',
                                },
                            },
                        }}
                    />
                </Grid>

                {/* About */}
                <Grid size={{ md: 12 }} >
                    <Box display="flex" justifyContent="space-between">
                        <Typography variant="body2" sx={{ fontSize: '13px', color: '#6e6464' }}>About You</Typography>
                        <Typography variant="caption" sx={{ fontSize: '9px', color: '#6e6464' }}>{wordCount}/100 Words</Typography>
                    </Box>
                    <TextField
                        fullWidth
                        multiline
                        minRows={4}
                        value={formData.aboutMe}
                        onChange={handleChange("aboutMe")}
                        sx={{
                            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
                            borderRadius: '10px',
                            '& .MuiOutlinedInput-root': {
                                minHeight: '145px',
                                borderRadius: '10px',
                                '& fieldset': {
                                    border: 'none',
                                },
                                '& input': {
                                    padding: '0 14px',
                                    minHeight: '145px',
                                    boxSizing: 'border-box',
                                },
                            },
                        }}
                    />
                </Grid>

                {/* Buttons */}
                <Grid size={{ md: 12 }} display="flex" justifyContent='end' gap={2}>
                    <Button
                        variant="contained"
                        sx={{
                            background: "#dce6f1",
                            color: "#000",
                            borderRadius: "20px",
                            px: 4,
                        }}
                        onClick={handleCancel}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        sx={{
                            background: "#dce6f1",
                            color: "#000",
                            borderRadius: "20px",
                            px: 4,
                        }}
                        onClick={handleSave}
                    >
                        Save
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default ProfileForm;